// import { Pie, mixins } from "vue-chartjs";
// const { reactiveProp } = mixins
// export default {
//   mixins: [reactiveProp],
//   extends: Pie,
//   props: ["data", "options"],
//   data: () => ({
//     options: {
//       borderWidth: "10px",
//       hoverBackgroundColor: "red",
//       hoverBorderWidth: "10px",
//       responsive: true,
//       maintainAspectRatio: false,
//       scales: {
//         yAxes: [
//           {
//             ticks: {
//               stepSize: 1
//             }
//           }
//         ]
//       }
//     }
//   }),
//   mounted() {
//     this.renderLineChart();
//   },
//   methods: {
//     renderLineChart() {
//       this.renderChart(this.chartData, this.options)
//     }
//   }
// };

import { Pie,mixins } from 'vue-chartjs'
import Plugins from 'chartjs-plugin-labels';
const { reactiveProp } = mixins

export default {
  mixins: [reactiveProp, Plugins],
  extends: Pie,
  data () {
    return {
      options: {
        legend: {
          display: true
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          labels: {
            fontSize: 14,
            fontStyle: 'bold',
            fontColor: ['white','black'],
            precision: 2
          },
        }
      }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}



// WEBPACK FOOTER //
// ./src/pages/utils/pieChart.js